<template>
  <div data-component-group="filter-forms" data-component="label">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import stringEscape from 'js-string-escape';
  import FiltersForm from './FiltersBase';
  import { isNonEmptyArr, isNull } from '../../../utils';

  // TODO: Translate component

  export default {
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        search: '',
        selectedCountries: [],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries } = this;

        return search !== '' || isNonEmptyArr(selectedCountries);
      },
    },
    methods: {
      onFilter() {
        const { search, selectedCountries } = this;
        const formattedSearch = isNull(search) ? '' : stringEscape(search);

        this.$emit('filter', {
          search: formattedSearch,
          countries: selectedCountries,
        });
      },
      onClearFilters() {
        this.search = '';
        this.selectedCountries = [];

        this.$emit('clearFilters');
      },
    },
  };
</script>
